export interface ComicChapter {
  num: string;
  title: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  status: "连载中" | "已完结";
  rating: number;
  views: number;
  description: string;
  longDescription: string;
  cover: string;
  tags: string[];
  latestChapter: string;
  updatedAt: string;
  isHot?: boolean;
  isNew?: boolean;
  chapters: ComicChapter[];
}

export interface Category {
  slug: string;
  name: string;
  desc: string;
  image: string;
}

export const categories: Category[] = [
  {
    slug: "yishijie",
    name: "异世界",
    desc: "转生异界、魔物横行、龙与魔法，主打开挂式冒险与异域日常。",
    image: "https://readdy.ai/api/search-image?query=epic%20anime%20manga%20key%20visual%20of%20a%20young%20swordsman%20in%20golden%20armor%20standing%20on%20a%20ruined%20cliff%20facing%20a%20giant%20fire%20breathing%20dragon%20in%20the%20sky%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20dynamic%20composition%2C%20high%20detail%20anime%20illustration%20with%20dramatic%20lighting%20and%20golden%20particles%20in%20the%20air&width=640&height=760&seq=cat-yishijie-01&orientation=portrait",
  },
  {
    slug: "chuanyue",
    name: "穿越",
    desc: "现代知识撞上古代江湖，机甲战武侠、魔法搅乱王权，脑洞式历史重演。",
    image: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20showing%20a%20modern%20person%20in%20futuristic%20armor%20mecha%20stepping%20through%20a%20golden%20time%20portal%20into%20an%20ancient%20oriental%20fantasy%20world%20with%20pagodas%2C%20warm%20amber%20and%20vermilion%20lighting%2C%20striking%20concept%20art%2C%20rich%20detail%20and%20cinematic%20atmosphere&width=640&height=760&seq=cat-chuanyue-01&orientation=portrait",
  },
  {
    slug: "qihuan",
    name: "奇幻",
    desc: "炼金、秘境、神秘图书馆，宏大世界观与瑰丽想象交织的奇异旅程。",
    image: "https://readdy.ai/api/search-image?query=magical%20anime%20manga%20key%20visual%20of%20a%20young%20mage%20holding%20a%20glowing%20golden%20tome%20in%20a%20vast%20mysterious%20library%20filled%20with%20floating%20books%20and%20amber%20candlelight%2C%20warm%20orange%20and%20gold%20color%20scheme%2C%20dreamy%20atmosphere%2C%20highly%20detailed%20illustration&width=640&height=760&seq=cat-qihuan-01&orientation=portrait",
  },
  {
    slug: "naodong",
    name: "脑洞",
    desc: "反向签到、打工魔王、全服首杀，用清奇设定刷新你的想象力上限。",
    image: "https://readdy.ai/api/search-image?query=creative%20anime%20manga%20cover%20of%20a%20playful%20hero%20in%20modern%20streetwear%20surrounded%20by%20floating%20golden%20lightbulbs%20and%20sparkles%20and%20game%20ui%20interface%20elements%2C%20warm%20amber%20and%20orange%20palette%2C%20whimsical%20energetic%20composition%2C%20detailed%20illustration%20with%20clean%20lines&width=640&height=760&seq=cat-naodong-01&orientation=portrait",
  },
  {
    slug: "xuanhuan",
    name: "玄幻",
    desc: "剑修问鼎、山海秘辛、焚天诀现世，气运加身的东方玄幻巨制。",
    image: "https://readdy.ai/api/search-image?query=xianxia%20wuxia%20anime%20manga%20cover%20of%20a%20sword%20cultivator%20in%20flowing%20dark%20robes%20levitating%20above%20mountains%20with%20a%20giant%20sword%20and%20golden%20sword%20qi%20light%2C%20warm%20amber%20gold%20and%20deep%20brown%20tones%2C%20epic%20oriental%20fantasy%2C%20highly%20detailed%20traditional%20style%20illustration&width=640&height=760&seq=cat-xuanhuan-01&orientation=portrait",
  },
];

export const comics: Comic[] = [
  {
    id: "jian-yu-longxi",
    title: "剑与龙息",
    author: "苍梧青",
    category: "yishijie",
    categoryName: "异世界",
    status: "连载中",
    rating: 9.4,
    views: 1286000,
    description: "为守护家园，少年剑士接受龙之试炼，踏上与巨龙同行的异界冒险。",
    longDescription:
      "大陆边缘的小镇少年凛，在巨龙袭击中失去了挚爱的家园。当传说中的赤焰龙王向他伸出契约之手，少年选择以剑为誓、以龙息为伴。这不是征服的旅程，而是两个孤独灵魂彼此救赎的故事。剑与火焰交织，热血与羁绊并存的异世界冒险，就此展开。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20swordsman%20with%20long%20dark%20hair%20holding%20a%20glowing%20golden%20sword%20beside%20a%20majestic%20red%20dragon%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20epic%20fantasy%20illustration%2C%20dramatic%20lighting%2C%20high%20detail%20and%20clean%20composition&width=520&height=700&seq=comic-jian-01&orientation=portrait",
    tags: ["龙族", "热血", "契约", "剑士"],
    latestChapter: "第128话 龙与少年",
    updatedAt: "今日更新",
    isHot: true,
    isNew: true,
    chapters: [
      { num: "第128话", title: "龙与少年" },
      { num: "第127话", title: "赤焰试炼" },
      { num: "第126话", title: "誓约之焰" },
      { num: "第125话", title: "断剑重铸" },
      { num: "第124话", title: "龙息觉醒" },
      { num: "第123话", title: "王城风云" },
      { num: "第122话", title: "暗影来袭" },
    ],
  },
  {
    id: "diyici-zhuansheng",
    title: "第七次转生",
    author: "墨染尘",
    category: "chuanyue",
    categoryName: "穿越",
    status: "连载中",
    rating: 9.1,
    views: 987000,
    description: "轮回七世，记忆不灭。这一次，他要在平行时空中改写自己的命运。",
    longDescription:
      "同一颗灵魂，已在这个世界辗转七世。每一次死去，都会带着上一世的记忆重新醒来。第八世的他决定不再重蹈覆辙——收集前七世积累的武学、魔法与科技，对抗那个让世界陷入轮回诅咒的幕后黑手。这是关于时间、记忆与救赎的穿越史诗。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20stoic%20man%20in%20mixed%20ancient%20warrior%20armor%20with%20seven%20ghostly%20golden%20silhouettes%20behind%20him%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20time%20travel%20fantasy%2C%20mysterious%20dramatic%20atmosphere%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-dici-01&orientation=portrait",
    tags: ["轮回", "重生", "逆袭", "穿越"],
    latestChapter: "第86话 第八世",
    updatedAt: "昨日更新",
    isHot: true,
    chapters: [
      { num: "第86话", title: "第八世" },
      { num: "第85话", title: "七世遗产" },
      { num: "第84话", title: "轮回之谜" },
      { num: "第83话", title: "宿敌现身" },
      { num: "第82话", title: "记忆碎片" },
      { num: "第81话", title: "命运的岔路" },
    ],
  },
  {
    id: "shenyuan-tushuguan",
    title: "深渊图书馆",
    author: "星野眠",
    category: "qihuan",
    categoryName: "奇幻",
    status: "已完结",
    rating: 9.6,
    views: 2103000,
    description: "每一本书都是一扇门，而图书馆的最深处，封印着世界的真相。",
    longDescription:
      "见习管理员珂朵莉发现，这座尘封的深渊图书馆里，每一本书都通往一个真实的世界。随着她整理藏书，隐藏于书页间的巨大秘密逐渐浮现——传说中封印毁灭魔王的古籍，其实就藏在书架的最深处。奇幻世界里的寻书之旅，温暖与危险并存。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20young%20girl%20librarian%20with%20floating%20golden%20books%20around%20her%20inside%20a%20vast%20mysterious%20dark%20library%20with%20warm%20candle%20glow%2C%20amber%20and%20gold%20color%20scheme%2C%20whimsical%20and%20cozy%20fantasy%2C%20detailed%20illustration&width=520&height=700&seq=comic-shenyuan-01&orientation=portrait",
    tags: ["魔法", "治愈", "冒险", "世界门"],
    latestChapter: "全128话",
    updatedAt: "已完结",
    isHot: true,
    chapters: [
      { num: "第128话", title: "书的尽头" },
      { num: "第127话", title: "封印解除" },
      { num: "第126话", title: "真相之书" },
      { num: "第125话", title: "深渊之心" },
      { num: "第124话", title: "失落的篇章" },
    ],
  },
  {
    id: "naodong-chibian",
    title: "我靠脑洞吃遍异世",
    author: "南瓜汽水",
    category: "naodong",
    categoryName: "脑洞",
    status: "连载中",
    rating: 9.0,
    views: 1504000,
    description: "别人穿越靠系统，我穿越靠脑洞。烧饼里夹魔法，火锅涮龙肉。",
    longDescription:
      "美食博主阿满一觉醒来，被丢进一个没有美食的蛮荒异世界。没有金手指系统，只有满脑子现代美食知识。于是——烤串刷上了火系魔法的辣酱，火锅涮起了龙肉，奶茶变成了畅销魔药。用脑洞和锅铲征服整个大陆的爆笑日常，敬请期待。",
    cover: "https://readdy.ai/api/search-image?query=playful%20anime%20manga%20cover%20of%20a%20happy%20chef%20in%20apron%20wielding%20a%20giant%20golden%20wok%20with%20steam%20and%20magical%20sparks%20and%20monsters%20smelling%20the%20food%20around%2C%20warm%20amber%20orange%20palette%2C%20comedic%20energetic%20composition%2C%20detailed%20illustration&width=520&height=700&seq=comic-naodong-01&orientation=portrait",
    tags: ["美食", "搞笑", "开挂", "异世界"],
    latestChapter: "第95话 火锅争霸",
    updatedAt: "今日更新",
    isNew: true,
    chapters: [
      { num: "第95话", title: "火锅争霸" },
      { num: "第94话", title: "烧烤摊风波" },
      { num: "第93话", title: "奶茶魔药" },
      { num: "第92话", title: "龙肉宴" },
      { num: "第91话", title: "铁锅炖魔兽" },
    ],
  },
  {
    id: "xuantian-jianxian",
    title: "玄天剑仙",
    author: "云中客",
    category: "xuanhuan",
    categoryName: "玄幻",
    status: "连载中",
    rating: 9.2,
    views: 1750000,
    description: "一剑破万法，万法归玄天。废柴少年的修仙逆袭之路。",
    longDescription:
      "玄天宗外门废柴陈北玄，被断定此生无缘大道。直到一场暴雨夜，他在藏经阁残卷中悟出失传的《玄天剑诀》。从此，剑随心动，万里破敌。宗门纷争、上古秘境、仙魔大战……且看废柴少年如何以手中之剑，问鼎玄天巅峰。",
    cover: "https://readdy.ai/api/search-image?query=xianxia%20anime%20manga%20cover%20of%20a%20young%20sword%20cultivator%20in%20dark%20flowing%20robes%20with%20a%20sword%20glowing%20golden%20light%20against%20mountains%2C%20warm%20amber%20gold%20and%20deep%20brown%20tones%2C%20epic%20oriental%20fantasy%2C%20highly%20detailed%20traditional%20style%20illustration&width=520&height=700&seq=comic-xuantian-01&orientation=portrait",
    tags: ["修仙", "剑修", "逆袭", "热血"],
    latestChapter: "第142话 问鼎玄天",
    updatedAt: "今日更新",
    isHot: true,
    chapters: [
      { num: "第142话", title: "问鼎玄天" },
      { num: "第141话", title: "万剑归宗" },
      { num: "第140话", title: "破境" },
      { num: "第139话", title: "秘境试炼" },
      { num: "第138话", title: "剑心通明" },
    ],
  },
  {
    id: "mowang-dagong",
    title: "魔王打工日记",
    author: "迟到的猫",
    category: "yishijie",
    categoryName: "异世界",
    status: "连载中",
    rating: 8.8,
    views: 846000,
    description: "魔王破产了，只好去勇者公会打工。异世界也有打工人的烦恼。",
    longDescription:
      "统治千年的魔王阿尔法，因为经营不善宣布破产，连魔王城都抵押给了银行。走投无路的他，只好隐姓埋名去勇者公会应聘冒险者。一边躲避勇者们的追杀，一边打工还债的爆笑异世界职场故事，就此上演。",
    cover: "https://readdy.ai/api/search-image?query=comedic%20anime%20manga%20cover%20of%20a%20handsome%20reluctant%20demon%20lord%20in%20modern%20office%20vest%20holding%20a%20sign%20saying%20help%20wanted%20with%20golden%20coin%20motifs%2C%20warm%20amber%20and%20orange%20palette%2C%20whimsical%20humorous%20composition%2C%20detailed%20illustration&width=520&height=700&seq=comic-mowang-01&orientation=portrait",
    tags: ["搞笑", "职场", "魔王", "日常"],
    latestChapter: "第70话 年终考核",
    updatedAt: "昨日更新",
    chapters: [
      { num: "第70话", title: "年终考核" },
      { num: "第69话", title: "被勇者盯上了" },
      { num: "第68话", title: "加班地狱" },
      { num: "第67话", title: "魔王也懂KPI" },
    ],
  },
  {
    id: "huidao-jixiashi",
    title: "回到武侠的机甲师",
    author: "钢铁明月",
    category: "chuanyue",
    categoryName: "穿越",
    status: "连载中",
    rating: 9.0,
    views: 1102000,
    description: "现代机甲师穿越到武侠世界，用科技碾压轻功暗器。",
    longDescription:
      "王牌机甲驾驶员沈砚在一次任务中意外穿越，落地竟然是刀光剑影的武侠江湖。内力？轻功？在火力覆盖面前统统黯然失色。他用现代机甲科技混迹武林，与各路高手斗智斗勇，上演一出跨次元的降维打击。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20modern%20pilot%20in%20futuristic%20mecha%20armor%20standing%20in%20an%20ancient%20oriental%20martial%20arts%20world%20with%20pagodas%20and%20glowing%20golden%20gear%20parts%2C%20warm%20amber%20and%20vermilion%20palette%2C%20genre%20mashup%20illustration%2C%20high%20detail&width=520&height=700&seq=comic-jixia-01&orientation=portrait",
    tags: ["机甲", "武侠", "穿越", "爽文"],
    latestChapter: "第58话 火炮vs剑法",
    updatedAt: "今日更新",
    isNew: true,
    chapters: [
      { num: "第58话", title: "火炮vs剑法" },
      { num: "第57话", title: "武林大会" },
      { num: "第56话", title: "轻功追击" },
      { num: "第55话", title: "机甲初现" },
    ],
  },
  {
    id: "wudu-lianjin",
    title: "雾都炼金术士",
    author: "白鸽与煤灯",
    category: "qihuan",
    categoryName: "奇幻",
    status: "已完结",
    rating: 9.3,
    views: 1688000,
    description: "蒸汽与魔法共存的雾都，落魄炼金术士揭开尘封的贵族秘密。",
    longDescription:
      "在永远笼罩着薄雾的蒸汽之都，炼金术士伊森经营着一家无人问津的小店。直到一位神秘的贵妇人上门，委托他炼制传说中的「贤者之石」。随着配方一步步推进，伊森发现自己竟卷入了一场撼动整座雾都的权力阴谋。",
    cover: "https://readdy.ai/api/search-image?query=steampunk%20anime%20manga%20cover%20of%20a%20mysterious%20alchemist%20in%20long%20coat%20holding%20a%20glowing%20amber%20philosopher%20stone%20in%20a%20foggy%20gaslamp%20city%2C%20warm%20gold%20and%20deep%20brown%20palette%2C%20moody%20atmosphere%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-wudu-01&orientation=portrait",
    tags: ["蒸汽朋克", "魔法", "悬疑", "完结"],
    latestChapter: "全96话",
    updatedAt: "已完结",
    chapters: [
      { num: "第96话", title: "雾散之时" },
      { num: "第95话", title: "贤者之石" },
      { num: "第94话", title: "迷雾真相" },
      { num: "第93话", title: "炼金对决" },
    ],
  },
  {
    id: "qiandao-shiwan",
    title: "签到十万年的我",
    author: "不灭金乌",
    category: "naodong",
    categoryName: "脑洞",
    status: "连载中",
    rating: 9.0,
    views: 1235000,
    description: "别人签到送装备，我签到被封印十万年。醒来就是满级大佬。",
    longDescription:
      "被封印在秘境中的少年，每天靠「签到」打发时光，十年、百年、千年……整整十万年过去。当他破封而出，外界早已沧海桑田，而他的签到奖励也攒到了一个恐怖的数量级。一睁眼就是满级，随手一招就是上古神技，这波低调的嚣张谁顶得住？",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20calm%20young%20man%20in%20simple%20robes%20emerging%20from%20a%20golden%20seal%20crack%20with%20countless%20glowing%20golden%20treasure%20particles%20floating%2C%20warm%20amber%20and%20gold%20palette%2C%20cool%20triumphant%20expression%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-qiandao-01&orientation=portrait",
    tags: ["签到", "满级", "爽文", "封印"],
    latestChapter: "第112话 签到满级",
    updatedAt: "昨日更新",
    isHot: true,
    chapters: [
      { num: "第112话", title: "签到满级" },
      { num: "第111话", title: "破封而出" },
      { num: "第110话", title: "十万年盘点" },
      { num: "第109话", title: "上古遗迹" },
    ],
  },
  {
    id: "shanhai-yiwenlu",
    title: "山海异闻录",
    author: "北冥有鱼",
    category: "xuanhuan",
    categoryName: "玄幻",
    status: "连载中",
    rating: 9.5,
    views: 1897000,
    description: "以山海经为蓝图，少年游历神州，降服上古异兽、封印作祟精怪。",
    longDescription:
      "上古时期，山海经中记载的珍禽异兽尽数现世。少年游侠白泽手持《山海异闻录》，踏遍九州大地，收服九尾狐、烛龙、毕方等上古神兽，揭开一个个精怪背后的恩怨情仇。一部关于华夏神话、守护与成长的东方玄幻巨制。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20young%20wandering%20warrior%20with%20a%20golden%20tome%20surrounded%20by%20mythical%20chinese%20beasts%20like%20nine%20tailed%20fox%20and%20qilin%20in%20warm%20golden%20light%2C%20amber%20and%20crimson%20oriental%20palette%2C%20epic%20mythological%20atmosphere%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-shanhai-01&orientation=portrait",
    tags: ["神话", "神兽", "东方", "守护"],
    latestChapter: "第103话 烛龙之怒",
    updatedAt: "今日更新",
    isHot: true,
    chapters: [
      { num: "第103话", title: "烛龙之怒" },
      { num: "第102话", title: "九尾狐契约" },
      { num: "第101话", title: "毕方衔火" },
      { num: "第100话", title: "山海百兽图" },
    ],
  },
  {
    id: "yijie-chushizhang",
    title: "异界厨师长",
    author: "一把花椒",
    category: "yishijie",
    categoryName: "异世界",
    status: "已完结",
    rating: 8.9,
    views: 965000,
    description: "现代大厨穿越异界，用一勺中华料理征服巨龙与魔王。",
    longDescription:
      "国宴大厨老周，一睁眼成了异世界王国御膳房的小学徒。这里的贵族只吃水煮兽肉，魔王军队虎视眈眈。老周凭一柄炒勺、一口铁锅，用麻婆豆腐征服了挑剔的国王，用佛跳墙谈妥了与龙族的休战条约。美食无国界，更无次元界。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20confident%20chinese%20chef%20in%20white%20uniform%20holding%20a%20steaming%20golden%20wok%20of%20delicious%20food%20with%20dragons%20and%20monsters%20gathered%20around%20in%20warm%20amber%20lighting%2C%20appetizing%20warm%20color%20palette%2C%20detailed%20illustration&width=520&height=700&seq=comic-chushi-01&orientation=portrait",
    tags: ["美食", "异世界", "搞笑", "完结"],
    latestChapter: "全88话",
    updatedAt: "已完结",
    chapters: [
      { num: "第88话", title: "全宴终章" },
      { num: "第87话", title: "龙族宴席" },
      { num: "第86话", title: "佛跳墙" },
      { num: "第85话", title: "麻婆豆腐" },
    ],
  },
  {
    id: "quanfu-shouci",
    title: "全服首杀",
    author: "深夜法师",
    category: "naodong",
    categoryName: "脑洞",
    status: "连载中",
    rating: 9.1,
    views: 1338000,
    description: "全息游戏与真实世界重叠，普通玩家一夜间成为世界首杀的第一人。",
    longDescription:
      "全民网游《神域》正式上线，据说首杀世界BOSS的玩家将获得隐藏职业「神眷者」。技术平平的废宅玩家小林，靠一条意外发现的游戏BUG，抢在全服大佬之前完成首杀。从此，现实与游戏两个世界彻底纠缠在一起。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20young%20gamer%20with%20glowing%20game%20holographic%20interface%20and%20golden%20lightning%20sword%20defeating%20a%20giant%20boss%20monster%2C%20warm%20amber%20and%20orange%20game%20ui%20palette%2C%20epic%20dynamic%20composition%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-quanfu-01&orientation=portrait",
    tags: ["游戏", "系统", "逆袭", "虚拟现实"],
    latestChapter: "第77话 世界BOSS",
    updatedAt: "今日更新",
    isNew: true,
    chapters: [
      { num: "第77话", title: "世界BOSS" },
      { num: "第76话", title: "隐藏职业" },
      { num: "第75话", title: "全服震动" },
      { num: "第74话", title: "首杀之夜" },
    ],
  },
  {
    id: "chongsheng-faxue",
    title: "重生在魔法学院",
    author: "春和景明",
    category: "chuanyue",
    categoryName: "穿越",
    status: "连载中",
    rating: 8.7,
    views: 742000,
    description: "带着前世记忆重生，他在魔法学院里重新点亮属于自己的一道光。",
    longDescription:
      "意外身亡的学霸少年，重生在异世界一所魔法学院。这里魔法天赋至上，而他却是众人眼中的「零天赋」。凭借前世的学识与不屈的意志，他另辟蹊径，把数学、物理写进魔咒，开创出一条独一无二的魔法之路。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20determined%20teenager%20in%20wizard%20school%20uniform%20holding%20a%20book%20glowing%20with%20golden%20formula%20rune%20magic%20in%20a%20grand%20college%20hall%20lit%20by%20warm%20amber%20light%2C%20warm%20gold%20palette%2C%20hopeful%20atmosphere%2C%20detailed%20illustration&width=520&height=700&seq=comic-faxue-01&orientation=portrait",
    tags: ["学院", "重生", "魔法", "热血"],
    latestChapter: "第49话 学霸魔咒",
    updatedAt: "昨日更新",
    chapters: [
      { num: "第49话", title: "学霸魔咒" },
      { num: "第48话", title: "零天赋翻身" },
      { num: "第47话", title: "魔纹学导论" },
      { num: "第46话", title: "学院祭" },
    ],
  },
  {
    id: "xingchen-fangzhou",
    title: "星尘方舟",
    author: "长庚星",
    category: "qihuan",
    categoryName: "奇幻",
    status: "连载中",
    rating: 9.2,
    views: 1129000,
    description: "一艘载着最后人类与万千生灵的星尘方舟，驶向未知的星海。",
    longDescription:
      "世界崩坏之际，古老的星尘方舟载着残存的人类与万千奇异生灵，驶向深空。方舟之上，有人寻找新的家园，有人探寻世界的真相，也有人觊觎方舟之心。宏大的星海世界观，与命运、守护和希望交织的奇幻史诗。",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20gigantic%20golden%20ark%20spaceship%20sailing%20through%20a%20warm%20nebula%20of%20amber%20and%20red%20stardust%20with%20tiny%20figures%20on%20deck%2C%20warm%20gold%20and%20crimson%20space%20palette%2C%20grand%20epic%20atmosphere%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-xingchen-01&orientation=portrait",
    tags: ["星海", "冒险", "守护", "宏大"],
    latestChapter: "第64话 方舟之心",
    updatedAt: "今日更新",
    isHot: true,
    chapters: [
      { num: "第64话", title: "方舟之心" },
      { num: "第63话", title: "星海迷航" },
      { num: "第62话", title: "新家园" },
      { num: "第61话", title: "深空信号" },
    ],
  },
  {
    id: "fentian-jue",
    title: "焚天诀",
    author: "赤霄真人",
    category: "xuanhuan",
    categoryName: "玄幻",
    status: "连载中",
    rating: 9.0,
    views: 1016000,
    description: "焚尽诸天，成就无上大道。一个被废的少年点燃了整个修真界。",
    longDescription:
      "身负残缺灵根的少年楚天，被家族视为弃子。机缘之下，他在火海深处获得上古禁忌功法《焚天诀》。从此以火为刃、以身为炉，焚尽诸天万法，踏上一条无人走过的成圣之路。东方玄幻的热血燃向之作。",
    cover: "https://readdy.ai/api/search-image?query=xianxia%20anime%20manga%20cover%20of%20a%20burning%20boy%20wreathed%20in%20golden%20and%20crimson%20flames%20standing%20inside%20a%20raging%20fire%20formation%2C%20warm%20red%20and%20gold%20palette%2C%20fierce%20dramatic%20lighting%2C%20epic%20oriental%20fantasy%2C%20highly%20detailed%20illustration&width=520&height=700&seq=comic-fentian-01&orientation=portrait",
    tags: ["火系", "废柴逆袭", "成圣", "热血"],
    latestChapter: "第91话 燃诸天",
    updatedAt: "昨日更新",
    chapters: [
      { num: "第91话", title: "燃诸天" },
      { num: "第90话", title: "火之觉醒" },
      { num: "第89话", title: "焚天初成" },
      { num: "第88话", title: "火海秘境" },
    ],
  },
];